import type { InquirePayload } from './graph/inquire.graphql'


const getRealPurchaseLevel = (items: InquirePayload['purchaseInquiry']['data']['items']): PaymentModule.PurchaseLevel => {
  const hasEcommerce = Boolean(items.products)
  const hasSubscription = Boolean(items.subscription)
  const hasGiftSubscription = Boolean(items.giftSubscription)
  const hasGiftCard = Boolean(items.giftCard)

  if (hasGiftSubscription || hasGiftCard) {
    if (hasGiftSubscription && !hasGiftCard && !hasEcommerce && !hasSubscription) {
      return 'GIFT_SUBSCRIPTION_ONLY'
    }

    if (hasGiftCard && !hasGiftSubscription && !hasEcommerce && !hasSubscription) {
      return 'GIFT_CARD_ONLY'
    }

    // if we have overlapping items, use all
    return 'ALL'
  }

  if (hasSubscription && hasEcommerce) {
    return 'ECOMMERCE_AND_SUBSCRIPTION'
  }

  if (hasSubscription) {
    return 'SUBSCRIPTION_ONLY'
  }

  if (hasEcommerce) {
    return 'ECOMMERCE_ONLY'
  }

  return null
}

// TODO to ask Backend change this logic and return subTotal price without shipping price and without discount (only product price) - added on 1/04/22 by vkudla
export const getSubTotal = (items): number => {
  let subTotal: number = 0
  const productTypes = [ 'subscription', 'products', 'giftSubscription', 'giftCard', 'queueItems' ]

  productTypes.forEach((productType) => {
    if (!items[productType] || (Array.isArray(items) && !items[productType].length)) {
      return
    }

    if (productType === 'products' || productType === 'queueItems') {
      subTotal += items[productType].reduce((result, item) => result + item.price, 0)
      return
    }

    subTotal += items[productType].price
  })

  return subTotal
}

const modifyInquire = (data: InquirePayload['purchaseInquiry']['data'], requestedPurchaseLevel: PaymentModule.PurchaseLevel): PaymentModule.InquireData => {
  // process orders data
  const { items, total } = data

  // we need to calculate the real level only when the requested one is ALL
  const realPurchaseLevel = requestedPurchaseLevel === 'ALL' ? getRealPurchaseLevel(items) : requestedPurchaseLevel

  const hasEcommerce = Boolean(items.products)
  const hasSubscription = Boolean(items.subscription)
  const hasGiftSubscription = Boolean(items.giftSubscription)
  const hasGiftCard = Boolean(items.giftCard)
  const hasQueueItems = Boolean(items.queueItems)

  const giftSubscriptionOfferCount = items.giftSubscription?.offer?.freeProductsAmount

  const subTotal = getSubTotal(items)

  const isGiftsOnly = (hasGiftCard || hasGiftSubscription) && (!hasEcommerce && !hasSubscription)

  const isEmpty = (
    !hasEcommerce
    && !hasSubscription
    && !hasGiftCard
    && !hasGiftSubscription
    && !hasQueueItems
  )

  // check if it's chargeable or free
  let isChargeable

  const coupon = items?.subscription?.coupon

  // credit card and express checkout buttons should be visible to get payment info from user for recurrent
  // payments in future. Exception: user has "coupon.shouldCharge: false"
  if (realPurchaseLevel === 'SUBSCRIPTION_ONLY') {
    isChargeable = coupon?.shouldCharge !== false
  }
  else if (realPurchaseLevel === 'ECOMMERCE_AND_SUBSCRIPTION') {
    // Exception: if "coupon.shouldCharge: false" which means that subscription is free; and total is 0
    isChargeable = !(coupon?.shouldCharge === false && total === 0)
  }
  else {
    isChargeable = total > 0
  }

  return {
    items,
    subTotal,
    total,
    hasEcommerce,
    hasSubscription,
    hasGiftCard,
    hasGiftSubscription,
    hasQueueItems,
    giftSubscriptionOfferCount,
    isGiftsOnly,
    isChargeable,
    isEmpty,
    requestedPurchaseLevel,
    realPurchaseLevel,
  }
}


export default modifyInquire
